import React, {Component} from 'react';
import {
    Switch,
    Route
} from 'react-router-dom';

// dinamically create app routes
import appRoutes from 'routes/app.jsx';
import { AuthenticatedRoute } from 'services/AuthService.jsx';

import Log from 'services/Log.jsx'



class App extends Component{
    componentDidUpdate(e){
        if(window.innerWidth < 993 && e.history.action === "PUSH" && document.documentElement.className.indexOf('nav-open') !== -1){
            document.documentElement.classList.toggle('nav-open');
        }
    }
    render(){
        Log.debug("[App] " + JSON.stringify(this.props));
        return (
            <Switch>
                {
                    appRoutes.map((prop,key) => {
                      if (prop.auth) {
                        return (<AuthenticatedRoute path={prop.path} component={prop.component} {...this.props} key={key}/>);
                      } else {
                        return (<Route path={prop.path} component={prop.component} {...this.props} key={key}/>)
                      }
                    })
                }
            </Switch>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx